import React from 'react';
import LoadingBanner from "../../../components/LoadingBanner";
import ErrorBanner from "../../../components/ErrorBanner";
import Component from '../../../components/Component'
import User from "../../../models/User";
import {Img} from "react-image";
import LoadingSpinner from "../../../components/LoadingSpinner";
import Form from "../../../components/form/Form";
import {Link} from "react-router-dom";
import Interview from "../../../models/Interview";
import AvailabilityPanel from "../../talent-dashboard/components/AvailabilityPanel";
import {AuthContext} from "../../../providers/AuthProvider";
import UserImageCircle from "../../../components/UserImageCircle";

export default class TalentAssessmentModal extends Component {

    static type = '';

    //contextType of the component is AuthContext. i.e this.context.auth = TB auth user
    static contextType = AuthContext;
    // static events() {
    //     return {
    //         "Talent@TalentVettingUpdated": (component, talent) => {
    //             if (component.state.talent?.id === talent?.id && !component.state.isLoading) {
    //                 component.setState({talent})
    //             }
    //         }
    //     }
    // };

    constructor(props) {
        super(props);

        this.modalRef = React.createRef();
        this.state = {
            isLoading: true,
            talent: props.talent
        }
    }

    async componentDidMount() {
        await super.componentDidMount();
        await this.loadTalent();
    }

    profileScoring() {
        return [
            {
                label: 'Roles',
                propName: 'talent_disciplines',
                scorable: true
            },
            {
                label: 'Skills',
                propName: 'skills'
            },
            {
                label: 'Project Interests',
                propName: 'talent_service_groups',
                scorable: true
            },
            {
                label: 'Industry Experience',
                propName: 'industries_worked'
            }
        ]
    }

    selfScore(score){
        return laravel.talent_scoring_options[score]
    }

    type() {
        return this.constructor.type
    }

    async loadTalent() {
        let talent = await User.fetchForTalentAsManager(
            this.props.talent.id
        );

        if (!talent) {
            return this.handleErrorResponse(
                User.FetchForTalentAsManagerRequest, {
                    500: 'error_show_talent',
                    404: 'error_talent_not_found',
                }
            );
        }

        let interview = talent.managerInterview();

        await this.promisedState({
            talent,
            assessment: {...interview},
            hasStarted: interview.assessmentStarted(this.type()),
            isLoading: false
        });
    }

    async approveAssessment() {
        if (await this.checkAssessmentProgress()) {

            let interview = Interview.make({
                ...this.state.assessment,
                [`${this.type()}_approved_at`]: new Date(),
                [`${this.type()}_rejected_at`]: null
            });
            if (!interview.is_approved && interview.hrWasApproved() && interview.capabilityWasApproved()) {
                interview.is_approved = true;
            }

            return this.submitAssessment({...interview})
        }
    }

    async rejectAssessment() {
        if (await this.checkAssessmentProgress()) {
            let interview = Interview.make({
                ...this.state.assessment,
                [`${this.type()}_rejected_at`]: new Date(),
                [`${this.type()}_approved_at`]: null
            });

            if (!interview.is_approved && interview.hrWasApproved() && interview.capabilityWasApproved()) {
                interview.is_approved = true;
            }

            return this.submitAssessment({...interview});
        }
    }

    async checkAssessmentProgress() {

        let interview = null;
        if (this.state.assessment) {
            let interviewProps = TB.pick({...this.state.talent},
                ['talent_disciplines', 'talent_service_groups', 'skills', 'talent_skill_score']
            );

            interview = Interview.make({...interviewProps, ...this.state.assessment})
        }
        if ((interview || this.state.talent.managerInterview()).assessmentMissingScores(this.type())) {
            let confirm = await TB.alert('warning','Assessment Not Finished',
                'The assessment has missing scores. Are you sure you want to submit your decision?',
                [{title: 'Yes, Continue'}, {title: 'Cancel'}]
            );

            return confirm
        }
        return true
    }

    async submitAssessment(assessment) {

        await this.promisedState({isEditing: false, isLoading: "Submitting Assessment"});

        await this.props.requestScroll();

        let {
            talent_service_groups = [],
            talent_disciplines = [],
            skills,
            talent_skill_score,
            ...interview
        } = assessment;


        interview[`${this.type()}_interviewer_id`] = this.context?.auth?.id

        let interviewUpdateParams = {
            interview
        }
        if (this.type() === 'capability') {
            interviewUpdateParams = {
                interview,
                talent_disciplines,
                talent_service_groups,
                talent_skill_score
            }
        }
        let updatedTalent = await User.submitInterview(this.state.talent.id, interviewUpdateParams);

        if (!updatedTalent) {
            console.error(User.UpdateInterviewForTalentManagerRequest.errorMessage());
            User.UpdateInterviewForTalentManagerRequest.didHandleError = await User.UpdateInterviewForTalentManagerRequest.handleError();
            if (User.UpdateInterviewForTalentManagerRequest.didHandleError
                && User.UpdateInterviewForTalentManagerRequest.shouldRerun) {
                return this.submitAssessment(assessment);
            }
            return
        }
        interview = updatedTalent.managerInterview();


        await this.promisedState({
            talent: updatedTalent,
            assessment: {...interview},
            hasStarted: interview.assessmentStarted(this.type())
        })
        await TB.wait(400);

        await this.promisedState({
            isLoading: false
        })


        await TB.toast(`${TB.startCase(this.type())} Assessment Submitted`);
    }

    render() {
        let {
            talent,
            isLoading,
            isDisabled,
            error
        } = this.state;

        return (
            <div className="talent-assessment-modal">

                <div className="assessment-modal-container">

                    {isLoading && <LoadingBanner message={TB.isString(isLoading) ? isLoading : "Loading"}/>}

                    {TB.isObject(error) && (
                        <ErrorBanner {...error} onRetry={this.loadTalent.bind(this)}/>
                    )}

                    {!isLoading && !error && this.renderAssessment()}

                </div>

            </div>
        );
    }


    renderAssessment() {
        let {
            talent,
            isEditing
        } = this.state;

        let interview = talent.managerInterview();

        return (
            <div className="flex flex-col items-stretch">
                <div className="user-info" style={{flexBasis: '100%'}}>
                    <div className="user-details">
                        <div className="user-info-image">
                            <Img
                                loader={(
                                    <div className="img-fluid img-loader"><LoadingSpinner/></div>
                                )}
                                unloader={<UserImageCircle user={talent} hideTooltip={true} size={90}/>}
                                src={talent.image_path}
                                className="img-grayscale img-fluid"/>
                        </div>
                        <div className="user-info-details">
                            <p><b>Name:</b> {talent.fullName()}</p>

                            <p>
                                <b>Job Title:</b> {talent.job_title ? TB.truncate(
                                TB.capitalize(talent.job_title), {length: 50}
                            ) : 'N/A'}
                            </p>

                            <p>
                                <b>Location:</b> {talent.location ? <span>
                                {talent.location.city}{!!talent.location.state && `, ${talent.location.state}`}
                            </span> : 'N/A'}
                            </p>

                            <p>
                                <b>Email:</b> {talent.email ? (
                                <a href={`mailto:${talent.email}`} target="_blank">{talent.email}</a>
                            ): 'N/A'
                            }
                            </p>
                            {talent.phone && (
                                <p>
                                    <b>Phone:</b> {talent.phone ? (
                                    <a href={`tel:${talent.phone}`} target="_blank">{talent.phoneNumber()}</a>
                                ): 'N/A'}
                                </p>
                            )}
                            <p><b>Registered At:</b> {talent.registered_at ? TB.moment(talent.registered_at).format('ll') : "N/A"}</p>


                        </div>
                    </div>

                    {!isEditing ? this.renderAssessmentScore(): (
                        <div className="user-instructions">
                            <h4>RATINGS LEGEND</h4>
                            <p>1 - does not meet our standard</p>
                            <p>2 - has some of what we want but not quite enough to feel confident</p>
                            <p>3 - good enough to be a solid contributor on a project</p>
                            <p>4 - has most of what we're looking for; great craft and could lead</p>
                            <p>5 - Knocks it out of the park. Top performer.</p>
                        </div>
                    )}


                </div>
                {!isEditing && (
                    <div className="assessment-actions">
                        <Link target="_blank" to={`/talent-profiles/${talent.id}`}
                              className="btn btn-dark btn-xs mx-2">
                            View Client-Facing Profile
                        </Link>
                        <button onClick={() => {
                            this.setState({isEditing: true})
                        }} className="btn btn-primary btn-xs mx-2">
                            {this.state.hasStarted ? 'Edit/View Assessment': 'Start Assessment'}
                        </button>

                        {this.state.hasStarted && (
                            interview.hasAssessmentStatus(this.type()) ? (
                                <button onClick={interview.assessmentWasApproved(this.type())
                                    ? this.rejectAssessment.bind(this)
                                    : this.approveAssessment.bind(this)
                                } className={TB.mapClass("btn btn-xs mx-2", {
                                    'btn-success': interview.assessmentWasRejected(this.type()),
                                    'btn-danger': interview.assessmentWasApproved(this.type()),
                                })}>
                                    Change Status to {interview.assessmentWasApproved(this.type()) ? 'Rejected' : 'Approved'}
                                </button>
                            ) : [
                                <button key="approve-btn" onClick={this.approveAssessment.bind(this)}
                                        className="btn btn-xs btn-success mx-2">
                                    <i className="fas fa-thumbs-up"/>
                                    Approve Talent
                                </button>,
                                <button key="reject-btn" onClick={this.rejectAssessment.bind(this)}
                                        className="btn btn-xs btn-danger mx-2">
                                    <i className="fas fa-thumbs-down"/>
                                    Reject Talent
                                </button>
                            ]
                        )}

                    </div>
                )}

                {!isEditing ? this.renderProfileDetails() : (
                    <Form
                        ref={this.formRef}
                        title={null}
                        subtitle={null}
                        showRequired
                        submitButton={false}
                        onSubmit={model => {
                            let assessment = {
                                ...this.state.assessment
                            };
                            for (let [prop, value] of Object.entries(model)) {
                                assessment = TB.set(assessment, prop, value)
                            }
                            return this.submitAssessment(assessment)
                        }}
                        onChange={model => {
                            console.log('model', model);
                            // let assessment = {
                            //     ...this.state.assessment
                            // };
                            // for (let [prop, value] of Object.entries(model)) {
                            //     assessment = TB.set(assessment, prop, value)
                            // }
                            this.setState({assessment: model})
                        }}
                        model={this.state.assessment}
                        fields={this.formFields()}
                        isDisabled={this.props.isDisabled}>
                        <div className="assessment-form-actions mt-3">
                            <button type="button" onClick={async() => {
                                await this.promisedState({isEditing: false});
                                return this.props.requestScroll()
                            }} className="btn btn-dark btn-sm mx-2">
                                Cancel
                            </button>

                            {this.state.hasStarted ? (
                                <button type="submit" className="btn btn-primary btn-sm mx-2">
                                    Update Assessment
                                </button>
                            ) : [
                                <button key="save-form-btn"
                                        type="submit"
                                        className="btn btn-xs btn-primary mx-2">
                                    Save Assessment
                                </button>,
                                <button key="approve-form-btn"
                                        type="button"
                                        onClick={this.approveAssessment.bind(this)}
                                        className="btn btn-xs btn-success mx-2">
                                    <i className="fas fa-thumbs-up"/>
                                    Submit & Approve Talent
                                </button>,
                                <button key="reject-form-btn"
                                        type="button"
                                        onClick={this.rejectAssessment.bind(this)}
                                        className="btn btn-xs btn-danger mx-2">
                                    <i className="fas fa-thumbs-down"/>
                                    Submit & Reject Talent
                                </button>
                            ]}

                        </div>
                    </Form>
                )}

            </div>
        )
    }

    renderAssessmentScore() {
        return <div/>
    }

    renderProfileDetails() {
        let {
            talent
        } = this.state;

        return (
            (<div className="flex flex-row flex-wrap profile-details">
                <div className="w-full flex flex-col items-stretch justify-center">
                    <AvailabilityPanel user={talent} readOnly={true} columnProps={{xl: 12, lg: 12}} colClass="!md:w-full lg:!w-full xl:!w-full xl:!max-w-[auto] xl:!basis-auto" />
                    <hr/>
                </div>
                {this.profileScoring().map(({label,propName}) => {
                    let items = talent[propName];

                    return (
                        (<div className="w-full" key={TB.slugify(label)}>
                            <h4 className="text-underline text-lg">
                                {label}
                            </h4>
                            {items?.length > 0 ? (
                                <ul className="list-disc pl-4 flex-wrap md:flex">
                                    {TB.map(items, item => (
                                        <li key={`${TB.slugify(label)}-${item.id}`} className="text-xs pr-6 p-2.5 md:basis-1/3 lg:basis-1/4">
                                            <p>
                                                {item.name}
                                            </p>
                                            {/* {TB.isDefined(item.self_score) && (
                                                <span>, {this.selfScore(item.self_score)}</span>
                                            )} */}
                                             {TB.isDefined(item.self_score) && (
                                                // <p className="p-0.5 bg-secondary text-white inline-block">{this.selfScore(item.self_score)}</p>
                                                (<p className="text-xxs font-bold">{this.selfScore(item.self_score)}</p>)

                                            )}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <h5 className="text-center text-muted italic">
                                    None Submitted
                                </h5>
                            )}
                            <hr/>
                        </div>)
                    );
                })}
            </div>)
        );
    }

}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
    fieldHidden: {
        height: 0,
        width: 0,
        zIndex: -10,
        opacity: 0,
        position: 'absolute',
        left: -9999
    }
};